export default "__VITE_ASSET__xY_0Vf5F__"